import { mutationOptions, queryOptions } from '@tanstack/react-query';
import { http } from '../common/http-client';
import type { ScriptTagDto } from './model';

export const tagsQueryOptions = queryOptions({
  queryKey: ['标签列表'],
  queryFn: async () => {
    return queryTags();
  },
});

export const createTagMutationOptions = mutationOptions({
  mutationKey: tagsQueryOptions.queryKey,
  mutationFn: async (name: string) => {
    await saveTag(name);
  },
});

export const queryTags = async () => {
  return http.get('tags').json<ScriptTagDto[]>();
};

export const saveTag = async (name: string) => {
  return http
    .post('tags', {
      json: {
        name,
      },
    })
    .json<ScriptTagDto>();
};
